import React from "react";
import { LocaleProvider } from "./src/assets/helpers/LocaleProvider";

export const wrapPageElement = ({ element }) => {
  return (
    <LocaleProvider>
      {element}
    </LocaleProvider>
  );
};